<template>
  <div>
    <CRow>
      <CCol col="12">
        <CCard>
          <form id="createReferralCode" @submit="createReferralCode" >
          <CCardHeader>
            <CCol col="6" style="font-size: 25px;">تعديل كود الدعوة</CCol>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol sm="6">
                <CInput label="أدخل الكود "
                  id="name"
                  v-model="referralCode"
                  class="required"
                  placeholder="5050"
                  :invalidFeedback="errors.name"
                  required
                />
              </CCol>

              <CCol sm="6">
                <CTextarea
                  label='الوصف (اختياري)'
                  placeholder='ادخل الوصف '
                  rows='4'
                  v-model='description'
                  :invalidFeedback="errors.description"
                />
              </CCol>
            </CRow>
          </CCardBody>
          <CCardFooter>
            <CButton @click="validation()" type="submit" size="sm" color="primary" ><CIcon name="cil-check-circle"/> حفظ</CButton>
              &emsp;
            <CButton type="reset" size="sm" color="danger"><CIcon name="cil-ban"/> مسح </CButton>
          </CCardFooter>
          </form>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import swal from 'sweetalert'
export default {
  name: 'CreateCategory',
  data: function () {
    return {
      referralCode: '',
      errors: [],
      description: ''
    }
  },
  created () {
    this.$http
      .get(`${this.$hostUrl}invitation-codes/${this.$route.params.id}`)
      .then((response) => {
        const { code, description } = response.data.data.invitation_code
        this.referralCode = code
        this.description = description
      })
  },
  methods: {
    async createReferralCode (e) {
      e.preventDefault()
      const formData = new FormData()
      formData.append('code', this.referralCode)
      if (this.description) {
        formData.append('description', this.description)
      }
      formData.append('_method', 'put')
      this.errors = await this.postRequest(formData, this.$hostUrl + 'invitation-codes/' + this.$route.params.id, '/referral-codes')
    },
    validation () {
      const Allinput = document.querySelectorAll('form input')
      Allinput.forEach((input) => {
        // eslint-disable-next-line valid-typeof
        input.oninput = function () {
          input.classList.remove('redborder')
        }
        if (input.value === '' && input.type === 'text') {
          input.classList.add('redborder')
          swal(' لا يمكن ترك الحقل فارغا')
          return 0
        }
      })
    }
  }
}

</script>
<style >
.redborder{
  border-color:red !important
}
</style>
